<i18n locale="en">
{
  "labels": {
    "global-nav": "Changes to the navigation affect all pages."
  }
}
</i18n>

<template>
  <div class="flex-col gap-8">
    <OwnType :text="t('labels.global-nav')" />
    <NavigationTransparencyEditor />
    <NavigationLogoPaletteEditor v-if="transparent" />
    <NavigationOrderEditor />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

import { OwnType } from '@/ui/OwnType'

import NavigationLogoPaletteEditor from './NavigationLogoPaletteEditor.vue'
import NavigationOrderEditor from './NavigationOrderEditor.vue'
import NavigationTransparencyEditor from './NavigationTransparencyEditor.vue'

const { t } = useI18n()
const store = useStore()

const transparent = computed(
  () =>
    store.getters['websiteBuilder/currentResource']?.funnel?.navigation
      ?.transparent ?? false
)
</script>
